.atm_7l_1hutuam{color:#202328;}
.atm_9s_1txwivl{display:flex;}
.atm_fc_1yb4nlp.atm_fc_1yb4nlp{justify-content:space-between;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_c8_1j6vyhq.atm_c8_1j6vyhq{font-size:1rem;}
.atm_g3_14xx0h6.atm_g3_14xx0h6{line-height:1.375;}
.atm_l8_9o6drx{padding:8px 16px;}
.atm_b3t7h3_118lp2q:hover,.atm_b3t7h3_118lp2q[data-focused='true']{background:#F4F5F7;}
.atm_7l_j1e0tf{color:#CED3DA;}
.atm_9j_13gfvf7{cursor:not-allowed;}
.atm_bb_idpfg4.atm_bb_idpfg4{flex-shrink:0;}
.atm_gz_exct8b.atm_gz_exct8b{margin-left:16px;}
.atm_vl_ewfl5b{visibility:visible;}
.atm_vl_15vqwwr{visibility:hidden;}
